import { render } from "./complaint_status_master.vue?vue&type=template&id=035cfa1c&scoped=true"
import script from "./complaint_status_master.vue?vue&type=script&lang=js"
export * from "./complaint_status_master.vue?vue&type=script&lang=js"

import "./complaint_status_master.vue?vue&type=style&index=0&id=035cfa1c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035cfa1c"]])

export default __exports__